import React from "react";
import { FaBell, FaCog, FaFileExport, FaSyncAlt } from "react-icons/fa";
import { ProgressRing, SERVICE_LABELS } from "./setupUi";

/** Overall ring, status counts, page actions and the client's DM services. */
function SetupProgressHeader({ setup, isStaff, busy, onRemind, onExport, onRunChecks, onEditTemplate }) {
  const { Progress: progress } = setup;
  const counts = progress.Counts || {};
  const services = setup.Tenant?.Services || [];
  const clientOpen = (setup.Client_Pending || []).filter((s) => s.Status !== "Submitted").length;

  return (
    <section className="dmc-card dms-hero">
      <ProgressRing pct={progress.Pct} />
      <div className="dms-hero__body">
        <div className="dms-hero__stats">
          <span>
            <strong>
              {progress.Steps_Done}/{progress.Steps_Total}
            </strong>{" "}
            steps done
          </span>
          <span>
            <strong>{counts["Waiting on Client"] || 0}</strong> waiting on client
          </span>
          <span>
            <strong>{counts.Submitted || 0}</strong> submitted for review
          </span>
          <span className={counts.Blocked ? "is-alert" : ""}>
            <strong>{counts.Blocked || 0}</strong> blocked
          </span>
        </div>

        <div className="dmp-actions dms-hero__actions">
          {isStaff ? (
            <button type="button" className="dmp-btn dmp-btn--sm" onClick={onRemind} disabled={busy || !clientOpen}>
              <FaBell aria-hidden="true" /> Remind client{clientOpen ? ` (${clientOpen})` : ""}
            </button>
          ) : null}
          <button type="button" className="dmp-btn dmp-btn--ghost dmp-btn--sm" onClick={onExport} disabled={busy}>
            <FaFileExport aria-hidden="true" /> Export summary
          </button>
          {isStaff ? (
            <button type="button" className="dmp-btn dmp-btn--ghost dmp-btn--sm" onClick={onRunChecks} disabled={busy}>
              <FaSyncAlt aria-hidden="true" className={busy === "checks" ? "dms-spin" : ""} /> Run all checks
            </button>
          ) : null}
          {isStaff && onEditTemplate ? (
            <button type="button" className="dmp-btn dmp-btn--ghost dmp-btn--sm" onClick={onEditTemplate}>
              <FaCog aria-hidden="true" /> Edit template
            </button>
          ) : null}
        </div>

        <div className="dms-hero__services">
          <span className="dms-hero__services-label">Services</span>
          {setup.Tenant?.Graphic_Design ? (
            <span className="dms-svc dms-svc--gd" title="Logo and brand kit are made by Cloud Office">
              Graphic Design (Branding)
            </span>
          ) : null}
          {services.length ? (
            services.map((s) => (
              <span key={s} className={`dms-svc dms-svc--${s.toLowerCase()}`}>
                {SERVICE_LABELS[s] || s}
              </span>
            ))
          ) : (
            <span className="dmp-muted">No DM service subscribed</span>
          )}
        </div>
      </div>
    </section>
  );
}

export default SetupProgressHeader;
